import { useEffect, useState } from 'react';
import { getProvidersPriority } from '@shared/services/services';

export const useProviderPriorities = () => {
  const [priorities, setPriorities] = useState({});
  const [isLoadingPriorities, setIsLoadingPriorities] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingPriorities(true);

      try {
        const response = await getProvidersPriority();

        setPriorities(response || {});
      } catch (error) {
        console.error('ERROR FETCHING PRIORITIES =>', error);
        setPriorities({});
      } finally {
        setIsLoadingPriorities(false);
      }
    };

    fetchData();
  }, []);

  return { priorities, isLoadingPriorities };
};
